import {
  AtsCvBulkUploadStatusesEnum,
  AtsGetCvBulkUploadsDocument,
  UpdateAtsCvBulkUploadStatusDocument,
  UpdateAtsCvBulkUploadStatusMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateCvBulkUploadStatus = (id: number) => {
  const [updateStatusAtsCvBulkUpload, { loading: updatingStatus }] = useMutation(
    UpdateAtsCvBulkUploadStatusDocument,
    {
      extractorFn: (data: UpdateAtsCvBulkUploadStatusMutation) =>
        data.atsMutations.updateStatusAtsCvBulkUpload,
    }
  )

  const updateBulkUploadStatus = (status: AtsCvBulkUploadStatusesEnum) =>
    updateStatusAtsCvBulkUpload({
      variables: { id, status },
      refetchQueries: [AtsGetCvBulkUploadsDocument],
    })

  return {
    updateBulkUploadStatus,
    updatingStatus,
  }
}
